import type { IntegrationMeta } from '@mint-lib/integration-registry';
import { PlatformUrns } from '@mint-sdk/api-integrations';

/**
 * Single source of truth for CM's registry metadata. Shared by `definition.ts`
 * (the `IntegrationDefinition.meta`) and by `manage-form`/`add-form` (display
 * name for chrome that isn't threaded through `AddFormProps`/`ManageFormProps`).
 */
export const cmIntegrationMeta: IntegrationMeta = {
  urn: PlatformUrns.TRAFFICKING_PLATFORM_URN.campaignManager,
  displayName: 'Campaign Manager 360',
  i18nNamespace: '@mint-lib/cm-integration',
  channel: 'adserver',
  direction: 'two-way',
  requiresGooglePolicyNotice: true,
};
